const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === 'localhost' ? 'http://localhost:5050' : '');

const postJson = async (path, payload) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data.message || 'Request failed.');
    error.status = response.status;
    throw error;
  }

  return data;
};

const postFormData = async (path, formData) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data.message || 'Request failed.');
    error.status = response.status;
    throw error;
  }

  return data;
};

export const submitContactForm = (payload) =>
  postJson('/api/forms/contact', payload);

export const submitFaqQuestionForm = (payload) =>
  postJson('/api/forms/faq-question', payload);

export const submitArticlesSubscription = (payload) =>
  postJson('/api/forms/articles-subscription', payload);

export const submitNewsletterSubscription = (payload) =>
  postJson('/api/forms/newsletter-subscription', payload);

export const submitCourseRegistration = (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return;
    }
    formData.append(key, value);
  });

  return postFormData('/api/forms/course-registration', formData);
};
